import { SpaPriorityTier } from 'quotes/components/ExportSkuPart/enums';
import { IAttributeForm } from 'quotes/components/ExportSkuPart/types';
import { SpaStatus } from 'quotes/enums';

export const getAttributeDefaultValues = (): IAttributeForm => ({
  project: null,
  projectCustomers: [],
  salesLocations: [],
  shippingLocations: [],
  customers: [],
  allCustomers: false,
  allSalesLocations: false,
  selectableSpaEnabled: false,
  spaPriorityTier: SpaPriorityTier.PRIORITY_3,
  spaStatus: SpaStatus.PLANNING,
  tradeAgreementOwner: null,
  tradeAgreementStartDate: null,
});
